import type { PublicFnbResponse } from '@nexacore/api-clients/fnb/public';

export type PublicMenu = NonNullable<NonNullable<PublicFnbResponse['data']>['menu']>;
export type PublicProduct = NonNullable<PublicMenu['products']>[number];
export type PublicStore = NonNullable<NonNullable<PublicFnbResponse['data']>['stores']>[number];
export type PublicVariant = NonNullable<PublicProduct['variants']>[number];
export type PublicModifierGroup = NonNullable<PublicProduct['modifierGroups']>[number];
export type PublicModifierOption = NonNullable<PublicModifierGroup['options']>[number];
export type PublicMedia = NonNullable<PublicProduct['media']>[number];

export function isAvailable(availability?: string): boolean {
  return !availability || availability.toLowerCase() === 'available';
}

export function formatMoney(amount?: number, currency = 'VND'): string {
  if (amount === undefined) return 'Liên hệ cửa hàng';
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function usableImage(reference?: string): string | undefined {
  if (!reference) return undefined;
  try {
    const url = new URL(reference, window.location.origin);
    const allowed = new Set(
      (import.meta.env.VITE_PUBLIC_MEDIA_ASSET_ORIGINS ?? '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
        .flatMap((value) => {
          try {
            return [new URL(value).origin];
          } catch {
            return [];
          }
        })
    );
    return url.origin === window.location.origin ||
      (url.protocol === 'https:' && allowed.has(url.origin))
      ? url.href
      : undefined;
  } catch {
    return undefined;
  }
}

export function usableMediaImage(media?: PublicMedia): string | undefined {
  return usableImage(media?.publicUrl) ?? usableImage(media?.reference);
}
